(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.OfficeDepot",
                {
                    url: "/OfficeDepot",
                    component: "officedepot",
                    PageTitle: "Office Depot",
                    requiredPermissions: "OfficeDepot:View",
                    resolve: {                       
                    }
                });
        }
    ]);

    app.component("officedepot",
        {
            templateUrl: "App/Resources/OfficeDepot/OfficeDepot.html",
            controller: officeDepotCtrl,
            bindings: {            
            }
        });

    officeDepotCtrl.$inject = ["amplitudeService"];
    function officeDepotCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
        /*this.launchOfficeDepotSso = function () {
            if (permissionService.hasOnePermission("OfficeDepot:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateOfficeDepotSso().then(function (data) {
                        //console.log(data);
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                    },
                    function (error) {
                        //TODO: Send email with all of user's info to be provisioned on Office Depot site.
                        console.log(error)
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };*/

    }
})(window.app, window.angular); // jshint ignore:line